<img class="modal-content" src="{{image}}">
